import { types as t, Instance } from '@invisr/mobx-state-tree'
import CredentialsProp from './credentialsProp'
import WhereUsed from './where-used'
import DSDeps from './datasource-dependencies'
import crudActions from './crud-actions'
import { getDataSourceDbKeyPrefix } from '../../utils/datasourceUtils'

export const GenericDataSource = t.model('GenericDS', {
    id: t.identifier,
    key: t.maybeNull(t.string)
  }).actions(crudActions).views(self => ({
    get dbKey () {
      return getDataSourceDbKeyPrefix(self) + self.id;
    }
  }))

const DefaultDS = t.compose(GenericDataSource, CredentialsProp, WhereUsed, DSDeps) 
export type WithDS<T> = T & Instance<typeof DefaultDS>
export default DefaultDS
